/**
 * Enums for Behavior
 * @module
 */

/**
 * Fields available in a behavior event.
 * @enum {string}
 */
exports.FIELDS = {
  NAME: 'n',
  TIME: 't',
  TYPE: 'y',
  CATEGORY: 'c',
  REVENUE: 'r',
  SESSION_ID: 's',
  OPTIONS: 'o',
  SESSION_INDEX: 'si',
};

/**
 * Map property names in the v0.2 rule spec to our internal field names.
 * @enum {string}
 */
exports.FIELDS_V0_2 = {
  name: exports.FIELDS.NAME,
  time: exports.FIELDS.TIME,
  type: exports.FIELDS.TYPE,
  category: exports.FIELDS.CATEGORY,
  tags: exports.FIELDS.OPTIONS,
  session_index: exports.FIELDS.SESSION_INDEX,
  //age: doesn't map to any underlying event field
};
